import { render, staticRenderFns } from "./CMPlayerComponent.vue?vue&type=template&id=1295521a&scoped=true"
import script from "./CMPlayerComponent.vue?vue&type=script&lang=ts"
export * from "./CMPlayerComponent.vue?vue&type=script&lang=ts"
import style0 from "./CMPlayerComponent.vue?vue&type=style&index=0&id=1295521a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1295521a",
  null
  
)

export default component.exports